import { styled } from "@mui/material";

export const HiddenDiv = styled('div')(({
  display: "flex",
  left: 0,
  top: 0,
  position: "absolute",
  transform: 'translateY(-200%)',
}));